export default __webpack_public_path__ + "static/media/11.b9efdbc1.png";